export const urlcode = 'https://kfjhapi.sjhlwyy.com/kfjh' //黑龙江郑州成都 正式
// export const urlcode = 'https://kfnbapi.sjhlwyy.com/kfnb'  //西安武汉 正式
// export const urlcode = 'https://kfbjapi.sjhlwyy.com/kfbj'  //北京军海 正式

// export const urlcode = 'http://192.168.40.31:1084/kfnb' //测试
// export const urlcode = 'https://kfnbtestapi.sjhlwyy.com/kfnb' //测试
// export const urlcode = 'http://192.168.40.49:1085/kfjh'  //fqf
// export const urlcode = 'http://192.168.40.49:1084/kfnb'  //yyl
export default {urlcode}




// WEBPACK FOOTER //
// ./src/config.js